import { NotificationType, NotificationTypeGroup } from '@/types/notification'

const WEB_PUSH_NOTIFICATION_SUBSCRIPTION_ID_LOCAL_STORAGE_KEY = 'web-push-notification-subscription-id'

export const WEB_PUSH_NOTIFICATION_SUBSCRIPTION_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  EXPIRED: 'expired',
} as const

export const NOTIFICATION_TYPE = {
  SCRAPE_WEBSITE_SUCCESS: 'scrape-website-success',
  SCRAPE_WEBSITE_FAIL: 'scrape-website-fail',
  SCRAPE_WEBSITE_PARTIAL: 'scrape-website-partial',
  TRAINED_FILE_SUCCESS: 'trained-file-success',
  TRAINED_FILE_FAIL: 'trained-file-fail',
  TRAINED_FILE_SKIP: 'trained-file-skip',
  CHAT_ESCALATION_REQUEST: 'chat-escalation-request',
  CHAT_ESCALATION_RESOLVED: 'chat-escalation-resolved',
  // @TODO: enable once live chat is ready
  LIVE_CHAT_REQUEST: 'live-chat-request',
  // @TODO: change depending on actual type
  // ORGANIZATION_USER_LEFT: 'organization-user-left',
} as const

export const NOTIFICATION_TYPE_GROUP = {
  TRAINING: 'training',
  CHAT_HISTORY: 'chat-history',
  // ORGANIZATION: 'organization',
} as const
export const NOTIFICATION_TYPE_GROUP_MAP = {
  [NOTIFICATION_TYPE_GROUP.TRAINING]: new Set<NotificationType>([
    NOTIFICATION_TYPE.SCRAPE_WEBSITE_SUCCESS,
    NOTIFICATION_TYPE.SCRAPE_WEBSITE_FAIL,
    NOTIFICATION_TYPE.SCRAPE_WEBSITE_PARTIAL,
    NOTIFICATION_TYPE.TRAINED_FILE_SUCCESS,
    NOTIFICATION_TYPE.TRAINED_FILE_SKIP,
    NOTIFICATION_TYPE.TRAINED_FILE_FAIL,
  ]),
  [NOTIFICATION_TYPE_GROUP.CHAT_HISTORY]: new Set<NotificationType>([
    NOTIFICATION_TYPE.CHAT_ESCALATION_REQUEST,
    NOTIFICATION_TYPE.CHAT_ESCALATION_RESOLVED,
  ]),
  // @TODO: change depending on actual type
  // [NOTIFICATION_TYPE_GROUP.ORGANIZATION]: new Set<NotificationType>([NOTIFICATION_TYPE.ORGANIZATION_USER_LEFT]),
} as const

export const WEB_PUSH_NOTIFICATION_SUBSCRIPTION_PLATFORM = {
  WEB: 'web',
  ANDROID: 'android',
  IOS: 'ios',
  PWA_WEB: 'pwa-web',
  PWA_ANDROID: 'pwa-android',
  PWA_IOS: 'pwa-ios',
  UNKNOWN: 'unknown',
} as const

export const NOTIFICATION_SSE_RETRY_DELAY = 3000
export const NOTIFICATION_SSE_MAX_RETRIES = 5

export function saveWebPushNotificationSubscriptionIdToLocalStorage(subscriptionId: string) {
  localStorage.setItem(WEB_PUSH_NOTIFICATION_SUBSCRIPTION_ID_LOCAL_STORAGE_KEY, subscriptionId)
}

export function clearWebPushNotificationSubscriptionIdFromLocalStorage() {
  localStorage.removeItem(WEB_PUSH_NOTIFICATION_SUBSCRIPTION_ID_LOCAL_STORAGE_KEY)
}

export function getWebPushNotificationSubscriptionIdFromLocalStorage() {
  return localStorage.getItem(WEB_PUSH_NOTIFICATION_SUBSCRIPTION_ID_LOCAL_STORAGE_KEY)
}

export function getNotificationGroupTypeFromType(type: NotificationType): NotificationTypeGroup {
  if (NOTIFICATION_TYPE_GROUP_MAP[NOTIFICATION_TYPE_GROUP.TRAINING].has(type)) {
    return NOTIFICATION_TYPE_GROUP.TRAINING
  }
  // if (NOTIFICATION_TYPE_GROUP_MAP[NOTIFICATION_TYPE_GROUP.ORGANIZATION].has(type)) {
  //   return NOTIFICATION_TYPE_GROUP.ORGANIZATION
  // }
  return NOTIFICATION_TYPE_GROUP.CHAT_HISTORY
}

export function getNotificationTypeFromGroup(group: NotificationTypeGroup): NotificationType[] {
  return Array.from(NOTIFICATION_TYPE_GROUP_MAP[group])
}
